import React from "react";
import { cn } from "../../lib/utils";
import MessageBubble from "./MessageBubble";

/**
 * Scrollable message list with optional "jump to bottom" button.
 * Renders messages using MessageBubble; admin can pass canManageMessages + delete handlers.
 * roleThatIsMe: 'staff' for admin view (outgoing = sent by staff), 'customer' for customer view.
 */
export default function ChatMessageList({
  messages = [],
  roleThatIsMe = "staff",
  senderRoleKey = "sender_role",
  mediaUrl,
  showSenderName = false,
  canManageMessages = false,
  onDeleteForMe,
  onDeleteForAll,
  listRef,
  onScroll,
  showJumpToBottom,
  onJumpToBottom,
  emptyMessage = "No messages yet.",
  className,
  /** Customer direct chat: JWT + profile rating for inline stars */
  appRatingToken,
  existingAppRating,
  onAppRated,
}) {
  return (
    <div
      ref={listRef}
      className={cn(
        "flex-1 min-h-0 overflow-y-auto p-4 bg-muted",
        className,
      )}
      onScroll={onScroll}
    >
      {showJumpToBottom && (
        <button
          type="button"
          onClick={onJumpToBottom}
          className="fixed bottom-24 right-8 z-20 px-3 py-2 rounded-full bg-primary text-white text-xs font-bold shadow-lg hover:opacity-90 transition"
        >
          New messages ↓
        </button>
      )}

      <div className="space-y-3">
        {messages.map((m, idx) => {
          const isOutgoing = m[senderRoleKey] === roleThatIsMe;
          return (
            <MessageBubble
              key={m.id ?? m.client_id ?? `msg-${idx}`}
              message={m}
              isOutgoing={isOutgoing}
              mediaUrl={mediaUrl}
              showSenderName={showSenderName}
              canManageMessages={canManageMessages}
              onDeleteForMe={
                onDeleteForMe ? () => onDeleteForMe(m.id) : undefined
              }
              onDeleteForAll={
                onDeleteForAll ? () => onDeleteForAll(m.id) : undefined
              }
              appRatingToken={roleThatIsMe === "customer" ? appRatingToken : undefined}
              existingAppRating={existingAppRating}
              onAppRated={onAppRated}
            />
          );
        })}
      </div>

      {messages.length === 0 && (
        <div className="flex items-center justify-center py-8 text-sm text-muted-foreground">
          {emptyMessage}
        </div>
      )}
    </div>
  );
}
